export default "__VITE_ASSET__hRR3qZIX__"